import React, { useState } from 'react';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';
import {
  Tabs,
} from 'antd';
import {
  myLeadsHeaderAtom,
} from '../../../../../atoms/Atoms';
import {
  thousand,
} from '../../../../../functions';
import LeadsSearchTable from './LeadsSearchTable';

function LeadsOpen({ className, orgReferral, useGlobal, isSetter }) {
  const { t } = useTranslation();
  const myLeadsHeader = useRecoilValue(myLeadsHeaderAtom);
  const { TabPane } = Tabs;
  const [selectedTab, setSlectedTab] = useState('open');

  return (
    <div className={className}>
      <Tabs activeKey={selectedTab} onChange={(tab) => setSlectedTab(tab)}>
        <TabPane key="open" tab={`${t('open')} (${thousand(myLeadsHeader?.totalAssigned)})`}>
          {selectedTab === 'open' && (
            <LeadsSearchTable orgReferral={orgReferral} useGlobal={useGlobal} isSetter={isSetter} searchType={2} />
          )}
        </TabPane>
        <TabPane key="revisit" tab={`${t('revisit')} (${thousand(myLeadsHeader?.totalRevisit)})`}>
          {selectedTab === 'revisit' && (
            <LeadsSearchTable orgReferral={orgReferral} useGlobal={useGlobal} isSetter={isSetter} searchType={8} />
          )}
        </TabPane>
        <TabPane key="failed_credit" tab={`${t('failed_credit')} (${thousand(myLeadsHeader?.totalFailedCredit)})`}>
          {selectedTab === 'failed_credit' && (
            <LeadsSearchTable orgReferral={orgReferral} useGlobal={useGlobal} isSetter={isSetter} searchType={7} />
          )}
        </TabPane>
      </Tabs>
    </div>
  );
}

export default LeadsOpen;
